export const ACTION = {
  getMessage: "getMessages",
};

export const MUTATION = {
  setWholeMessages: "setWholeMessages",
  appendMessage: "appendMessage",
};
